import { Skeleton } from "@sentricmusic/ui";

export function SongSuggestionsSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-2">
        <Skeleton className="flex-1 h-11 rounded-lg" />
        <Skeleton className="flex-1 h-11 rounded-lg" />
      </div>
      <div className="flex flex-col gap-3 p-4">
        {[0, 1, 2].map(i => (
          <div key={i} className="flex items-center gap-4">
            <Skeleton className="w-10 h-10 rounded shrink-0" />
            <Skeleton className="h-4 flex-1 max-w-xs" />
            <Skeleton className="hidden h-4 w-24 sm:block" />
            <Skeleton className="hidden h-4 w-20 sm:block" />
          </div>
        ))}
      </div>
    </div>
  );
}
